<template>
  <div class="insta-post-wrapper">
    <v-card class="instagram-post rounded-lg overflow-hidden" elevation="3">
      <!-- Header -->
      <div class="d-flex align-center pa-3">
        <v-avatar size="40" class="me-3">
          <img src="https://i.pravatar.cc/40" alt="user" />
        </v-avatar>
        <div class="d-flex flex-column me-2">
          <div class="d-flex align-center">
            <span class="font-weight-bold">caroline.fitness</span>
            <v-icon size="16" color="primary" class="ms-1"
              >mdi-check-decagram</v-icon
            >
          </div>
          <span class="text-caption text-grey">New York City</span>
        </div>
        <v-spacer />
        <v-icon>mdi-dots-horizontal</v-icon>
      </div>

      <!-- Image & Slide Count -->
      <div
        class="position-relative"
        style="max-height: 18rem; overflow: hidden"
        v-if="post?.file"
      >
        <img
          class="gallery-image w-100"
          v-if="
            post?.file?.file &&
            post?.file?.file?.type &&
            post?.file?.file?.type.startsWith('image/')
          "
          :src="post.file.preview"
          alt="Post Image"
        />
        <video
          v-if="
            post?.file?.file &&
            post?.file?.file?.type &&
            post?.file?.file?.type.startsWith('video/')
          "
          width="100%"
          :src="post?.file?.preview"
          autoplay
          muted
          loop
          class="gallery-image"
        ></video>
        <img v-else :src="post?.file?.preview" alt="">
      </div>
      <div v-else>
        <img src="@/assets/images/noimg.png" class="w-100" alt="" />
      </div>

      <!-- Interaction icons -->
      <div class="d-flex align-center pa-3 pt-2 pb-0">
        <v-icon class="me-3">mdi-heart-outline</v-icon>
        <v-icon class="me-3">mdi-comment-outline</v-icon>
        <v-icon>mdi-send-outline</v-icon>
      </div>

      <!-- Slider indicators -->
      <div class="d-flex justify-center align-center pb-2">
        <div v-for="n in 5" :key="n" :class="['dot', { active: n === 1 }]" />
      </div>

      <!-- Caption -->
      <div class="pa-3 pt-0 pb-4">
        <span class="font-weight-bold">{{ post?.user?.username }}</span>
        <span>
          {{ post?.caption }} || {{ post?.content }}
        </span>
        <span class="text-primary">#trip</span>
      </div>
    </v-card>
  </div>
</template>

<script>
import { publishPost } from "@/store/publishPost/publishPost.js";
import apiClient from "@/core/buildRequest";

export default {
  name: "InstgramPostReview",
  components: {},
  data() {
    return {
      store: publishPost(),
      post: {},
    };
  },
  methods: {
   getPost() {
    const postId = localStorage.getItem("postId");
   if(postId){
    apiClient.get("/get-scheduled-post", {
        params: { id: postId },
      }).then((res) => {
        this.post = res.data.data;
        console.log(this.post);
      });
   }else{
    this.$router.push({ name: "PublishPost" });
   }
    
   }
  },
  mounted() {
    this.getPost();
  },
  watch: {
    "store.getCarouselSlider": {
      handler() {
        this.post = this.store.post["instagram"].find(
          (item) => item.type === "post"
        );
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.insta-post-wrapper {
  width: 100%;
  max-width: 420px;
  margin: auto;
}

.instagram-post {
  width: 100%;
}

.dot {
  width: 6px;
  height: 6px;
  background-color: #cfcfcf;
  border-radius: 50%;
  margin: 0 3px;
}

.dot.active {
  background-color: #1976d2;
}
</style>
